import { listingType } from '../../shared/reducers/category-listing-type.reducer';
import { categoryUrlParams } from './category-url-params.reducer';
import { products } from './category-products.reducer';
import { modals } from '../../../reducers/modals';

export default {
    listingType,
    categoryUrlParams,
    products,
    modals
};
